import React from 'react';

const SVGComponent = props => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <title>icons/icon-edit</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      id="Proxy-Login-Refresh---Avatars---Web"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="H-Profile-Manage-Avatars" transform="translate(-562.000000, -288.000000)">
        <g id="Group-10" transform="translate(492.000000, 232.000000)">
          <g
            id="icons/icon-edit"
            transform="translate(70.150000, 55.943564)"
            filter="url(#filter-1)"
          >
            <g fill="#000000" id="icon-edit">
              <path
                d="M10.151,15.968 L11.9,14.233 L9.653,11.901 L7.904,13.636 L7.89,14.489 L9.326,14.503 L9.312,15.954 L10.151,15.968 L10.151,15.968 Z M16.836,5.116 C16.68,4.945 16.509,4.96 16.338,5.13 L11.047,10.378 C10.876,10.549 10.862,10.719 11.033,10.876 C11.189,11.032 11.36,11.032 11.531,10.862 L16.822,5.614 C16.993,5.443 16.993,5.273 16.836,5.116 L16.836,5.116 Z M16.622,2.926 L20.874,7.349 L10.719,17.433 L6.424,17.39 L6.467,13.024 L16.622,2.926 L16.622,2.926 Z M23.236,5.003 L21.842,6.383 L17.59,1.974 L18.984,0.594 C19.268,0.31 19.61,0.182 20.008,0.182 C20.406,0.182 20.748,0.338 21.018,0.623 L23.265,2.955 C23.535,3.239 23.677,3.581 23.677,3.993 C23.663,4.377 23.521,4.718 23.236,5.003 L23.236,5.003 L23.236,5.003 Z"
                id="Shape"
              />
              <path
                d="M20.334,21.074 C20.334,21.145 20.263,21.216 20.192,21.216 L2.756,21.216 C2.685,21.216 2.614,21.145 2.614,21.074 L2.614,3.325 C2.614,3.254 2.685,3.183 2.756,3.183 L11.73,3.183 L13.977,0.907 L2.756,0.907 C1.419,0.907 0.338,1.988 0.338,3.339 L0.338,21.088 C0.338,22.425 1.419,23.52 2.756,23.52 L20.192,23.52 C21.529,23.52 22.61,22.439 22.61,21.088 L22.61,10.45 L20.334,12.754 L20.334,21.074 L20.334,21.074 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SVGComponent;
